// Configurazione contatti: inserire il numero WhatsApp in formato internazionale senza "+" (es. 393331234567)
export const SITE_URL = "https://bdigitalstudios.it";

export const CONTACT = {
  email: "irene.borghi@gmail.com",
  whatsapp: "",
  whatsappText: "Ciao B Digital Studio, vorrei parlarvi del mio brand.",
  bookingIrene: "https://tidycal.com/ireneborghi/20-minute-meeting",
  bookingGiulia: "https://tidycal.com/giuliaborghi33/20minuti-conosciamoci-365pvqo",
};

export const NAV = [
  { to: "/studio", label: "Studio" },
  { to: "/servizi", label: "Servizi" },
  { to: "/progetti", label: "Progetti" },
  { to: "/contatti", label: "Contatti" },
];

export const SERVICES = [
  {
    id: "social",
    n: "01",
    title: "Strategia digitale & Social Media Management",
    lead: "Gestire i social non significa semplicemente scegliere cosa pubblicare.",
    text: "Analizziamo il tuo brand, il settore, il pubblico e gli obiettivi per costruire una strategia di comunicazione su misura. Ci occupiamo di Piani Editoriali, ideazione dei contenuti, copywriting, pubblicazione e analisi dei risultati, seguendo la tua comunicazione nel tempo.",
    includes: ["Analisi di brand, settore e pubblico", "Strategia di comunicazione su misura", "Piani Editoriali", "Ideazione dei contenuti e copywriting", "Pubblicazione e analisi dei risultati"],
    img: "/img/vetrine-borgo.webp",
  },
  {
    id: "produzione",
    n: "02",
    title: "Produzione Foto & Video",
    lead: "Le idee prendono forma attraverso le immagini.",
    text: "Organizziamo shooting fotografici e produzioni video professionali, occupandoci di ogni fase: dalla progettazione creativa alle riprese, fino al montaggio. Realizziamo Reel, video parlati, interviste, contenuti promozionali e format pensati per valorizzare la tua attività.",
    includes: ["Progettazione creativa", "Shooting fotografici", "Produzioni video e riprese", "Montaggio", "Reel, video parlati, interviste e contenuti promozionali"],
    img: "/img/shooting-attivita.webp",
  },
  {
    id: "ads",
    n: "03",
    title: "Advertising & Meta Ads",
    lead: "Non basta creare contenuti. Bisogna anche farli arrivare alle persone giuste.",
    text: "Progettiamo e gestiamo campagne pubblicitarie su Instagram e Facebook, definendo obiettivi, pubblico, creatività e budget. Monitoriamo le performance e ottimizziamo le campagne per aumentare la visibilità, generare contatti e sostenere gli obiettivi commerciali.",
    includes: ["Campagne su Instagram e Facebook", "Definizione di obiettivi e pubblico", "Creatività e budget", "Monitoraggio delle performance", "Ottimizzazione delle campagne"],
    img: "/img/adv-analisi.webp",
  },
  {
    id: "lancio",
    n: "04",
    title: "Strategie di lancio & Business per attività locali",
    lead: "Stai aprendo una nuova attività? Vuoi lanciare un servizio o riposizionare il tuo brand?",
    text: "Ti affianchiamo nella costruzione di una strategia che non si fermi alla comunicazione social. Studiamo il mercato, il pubblico, i competitor e il posizionamento della tua attività per definire come presentarti, cosa comunicare e quali azioni mettere in campo. Dalla fase di pre-lancio all'inaugurazione, fino alla promozione dei servizi e alla fidelizzazione dei clienti, costruiamo un piano di comunicazione e marketing pensato per sostenere la crescita della tua attività sul territorio.",
    includes: ["Analisi di mercato, pubblico e competitor", "Posizionamento dell'attività", "Pre-lancio e inaugurazione", "Promozione dei servizi", "Fidelizzazione dei clienti", "Piano di comunicazione e marketing"],
    img: "/img/video-call.webp",
  },
];

export const SERVICE_OPTIONS = [...SERVICES.map((s) => s.title), "Non lo so ancora, parliamone"];

export const METHOD = [
  { n: "01", title: "Ascolto", text: "Un primo incontro per capire il brand, il mercato, le persone a cui ti rivolgi e cosa non ha funzionato finora." },
  { n: "02", title: "Strategia", text: "Obiettivi, canali, tono di voce e piano editoriale messi per iscritto. Un documento chiaro, condiviso prima di produrre." },
  { n: "03", title: "Produzione", text: "Foto, video, Reel, testi e creatività per le campagne. Pensati per il calendario, girati con cura per il dettaglio." },
  { n: "04", title: "Gestione e lettura", text: "Pubblichiamo, seguiamo la community, leggiamo i dati e correggiamo la rotta. Il lavoro continua dopo il post." },
];
